import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _find from 'lodash/find';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Models
import mScenario from 'models/scenario';
import mSource from 'models/source';
import { isMotherboard } from 'models/deviceSlave';
// Custom
import { deviceDataShape, sourceDataShape } from 'constants/PropTypesShapes';
import { DeleteIconButton } from 'components/buttons/IconButtons';
import InformationItem from 'components/items/InformationItem';

const TriggerInputItem = ({
  inputTrigger, device, sources, onDelete,
}) => {
  const { slave, input, state } = mScenario.parseInputTrigger(inputTrigger, device);

  let nestedSources;
  if (input && !!sources) {
    const inputSources = input.sources;
    if (_size(inputSources) > 0) {
      nestedSources = _map(inputSources, (sourceId) => {
        const source = _find(sources, { id: sourceId });
        return ({
          key: _toString(source.id),
          icon: mSource.type(source).icon,
          label: <LocalizedMessage id={`source.type.${source.type}`} />,
          value: source.name,
        });
      });
    }
  }

  return (
    <InformationItem
      label={<LocalizedMessage id="title.deviceSlave" values={{ isMotherboard: isMotherboard(slave), desc: slave.name }} />}
      value={<LocalizedMessage id="info.inputTrigger" values={{ input: input ? input.code : 'unknown', state: _toString(state.value) }} />}
      icon={state.icon}
      iconColor={state.color}
      nestedItems={nestedSources}
      rightButton={onDelete ? <DeleteIconButton onClick={() => onDelete(inputTrigger)} /> : null}
    />
  );
};

TriggerInputItem.propTypes = {
  inputTrigger: PropTypes.string.isRequired,
  device: deviceDataShape,
  sources: PropTypes.arrayOf(sourceDataShape),
  onDelete: PropTypes.func,
};

TriggerInputItem.defaultProps = {
  device: null,
  sources: null,
  onDelete: null,
};

const mapStateToProps = (state) => ({
  sources: state.installationSource.list.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(TriggerInputItem);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/scenarios/TriggerInputItem.js